/**
 * Created by pzf on 18/9/1.
 *
 */
import PropTypes from 'prop-types';
import noop from '../_util/noop';


export const propTypes = {
  prefixCls: PropTypes.string,
  readonly: PropTypes.bool,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.array,
  maxSize: PropTypes.number,
  data: PropTypes.array,
  api: PropTypes.func, // 异步加载时会用到
  showSearch: PropTypes.bool,
  label: PropTypes.string,
  showLabel: PropTypes.bool,
};

export const defaultPropTypes = {
  prefixCls: 'mkui-fee-type-tags-select',
  onChange: noop,
  multiple: true,
  readonly: false,
  title: '',
  subTitle: '',
  value: [],
  data: [],
  maxSize: 10,
  api: noop,
  showSearch: false,
  label:'费用类型',
  showLabel: false,
};
